import { api } from 'api';

/**
 * add
 * @param {*} data
 * @returns
 */
export const addUser = (data) => {
  return api.call('users.add', data);
};

/**
 * update
 * @param {*} data
 * @returns
 */
export const updateUser = (data) => {
  return api.call('users.update', data);
};
